<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-相册-添加
    -->
    <el-dialog
    title="添加相册"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加相册</div>
    <!-- 全分类选择 -->
    <el-form-item label="选择全分类" prop="name" >
          <div>{{ form.categorya.name }}</div>
      
        <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为相册标题</el-button>
      </el-form-item>

      <el-form-item label="相册备注" prop="name"><el-input v-model="form.name" placeholder="请输入相册名称" class="max-w460"></el-input></el-form-item>
    
      <el-form-item label="相册图片">
        <div>
          <el-button type="primary" @click="openUpload(1)">上传图片</el-button>
  
          <img :src="form.image" class="mt10" width="120px;" v-if="isImg" :isImg="isImg" />
        </div>
      </el-form-item>

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas>
  </div>
</el-dialog>
  
</template>

<script>
import AlbumApi from '@/api/album.js';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
export default {
  components: {
    /*编辑器*/
    Uediter,
     /*图片上传*/
     Upload: Upload,
     Categoryas
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
            /*富文本配置*/
            ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:"",
        categorya:{},
        sort:50
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入相册名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[]
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.iscategorya = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          arr = {
            name: item.name,
            categorya_id: item.categorya_id,
            image: item.image,
          };
        }
        self.form.categorya = arr;
    
      }
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

        /*获取图片*/
        returnImgsFunc(e) {
      let self = this;
      console.log(e)
      if (e != null) {
        self.form.image_id = e[0].file_id;
          self.form.image = e[0].file_path;
          self.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      if(!form.categorya.categorya_id){
        self.$message({
                message:"请选择全分类",
                type: 'error'
              });
              return;
      }
      if(!form.image_id){
        self.$message({
                message:"请上传图片",
                type: 'error'
              });
              return;
      }
      form.categorya = JSON.stringify(form.categorya );
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          AlbumApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/album/part/add.vue